import React, { FC } from 'react'
import ChevronRight from '@mui/icons-material/ChevronRight'
import Email from '@mui/icons-material/Email'
import Phone from '@mui/icons-material/Phone'
import AvatarOrInitials from 'components/AvatarOrInitials'
import { Calendar } from './types'

type PointOfContactLinesProps = {
  calendar: Calendar
}

const PointOfContactLines: FC<PointOfContactLinesProps> = ({ calendar }) => {
  return (
    <>
      <div className="tw:flex tw:gap-2 tw:py-4">
        <AvatarOrInitials
          name={calendar.advisor.name}
          avatarUrl={calendar.advisor.profile_pic_url}
          className="tw:rounded-full tw:size-12 tw:shrink-0 tw:bg-neutrals-200"
        />
        <div>
          <div className="tw:font-semibold">{calendar.advisor.name}</div>
          <div className="tw:text-sm tw:text-tertiary-black">{'Project Operations Manager'}</div>
        </div>
      </div>
      {calendar.advisor.email && (
        <a
          href={`mailto:${calendar.advisor.email}`}
          target="_blank"
          rel="noreferrer"
          className="tw:flex tw:gap-4 tw:py-2 tw:items-center tw:text-sm tw:font-semibold tw:mt-2"
        >
          <div className="tw:size-8 tw:bg-neutrals-200 tw:shrink-0 tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <Email className="tw:!size-5" />
          </div>
          <div className="tw:grow">{calendar.advisor.email}</div>
          <ChevronRight className="tw:!size-5 tw:shrink-0" />
        </a>
      )}
      {calendar.advisor.phone_number && (
        <a
          href={`tel:${calendar.advisor.phone_number}`}
          target="_blank"
          rel="noreferrer"
          className="tw:flex tw:gap-4 tw:py-2 tw:items-center tw:text-sm tw:font-semibold"
        >
          <div className="tw:size-8 tw:bg-neutrals-200 tw:shrink-0 tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <Phone className="tw:!size-5" />
          </div>
          <div className="tw:grow">{calendar.advisor.display_phone_number || calendar.advisor.phone_number}</div>
          <ChevronRight className="tw:!size-5 tw:shrink-0" />
        </a>
      )}
    </>
  )
}

export default PointOfContactLines
